import Api from 'src/services/api';
import { PapiroConsole } from 'src/utils/papiroConsole';

export function addBreakReasonActive(breakreasonactive) {
  return {
    type: "ADD_BREAK_REASON_ACTIVE",
    breakreasonactive,
  };
}

export function removeBreakReasonActive() {
  return {
    type: "REMOVE_BREAK_REASON_ACTIVE",
  };
}

export function setFetchingBreakReasonActive(isFetching) {
  return {
    type: "SET_FETCHING_BREAK_REASON_ACTIVE",
    isFetching,
  };
}

export function setHasFetchedBreakReasonActive() {
  return {
    type: "SET_HAS_FETCHED_BREAK_REASON_ACTIVE",
  };
}

// Reseta todo o estado do breakworks (usado no logout)
export function resetBreakWorksState() {
  return {
    type: "RESET_BREAKWORKS_STATE",
  };
}

// Thunk action para buscar o break reason ativo (chamada única centralizada)
export function fetchActiveBreakReason() {
  return async (dispatch, getState) => {
    const { breakworks } = getState();

    // Evita chamadas duplicadas
    if (breakworks?.hasFetchedActive || breakworks?.isFetchingActive) {
      return;
    }

    dispatch(setFetchingBreakReasonActive(true));

    try {
      const result = await Api.get("/break-work/active");
      const response = result.data;

      if (response.success && response.data) {
        dispatch(addBreakReasonActive(response.data));
      } else {
        dispatch(setHasFetchedBreakReasonActive());
        if (!response.success) {
          PapiroConsole.log('BREAK_WORKS - Erro ao buscar motivo de pausa ativo:', response.error);
        }
      }
    } catch (err) {
      PapiroConsole.log('BREAK_WORKS - Erro ao buscar motivo de pausa ativo:', err);
      dispatch(setHasFetchedBreakReasonActive());
    }
  };
}